// CANONICAL COPY (GH #7115). src/constants/obligations/obl-security-event-reporting.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-security-event-reporting',
  title: 'Verify security event reporting mechanism',
  description:
    'Confirm that personnel have a documented mechanism to report observed or suspected information security events and vulnerabilities through appropriate channels in a timely manner. The mechanism shall be communicated to all personnel and cover both internal reporting and receipt of externally disclosed vulnerabilities.',
  category: 'people',
  scfIds: ['SCF-PPL-008'],
  cadence: { frequency: '1y', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [
    { type: 'document-published', description: 'Security event reporting procedure is published' },
    { type: 'document-acknowledged', description: 'Personnel have acknowledged the procedure' },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
